import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import SearchableMenu, { SEARCHABLE_MENU_ROW_CLASS } from '../../ui/SearchableMenu'
import StatusDot from '../IssueStatuses/StatusDot'

const filterByName = status => status.name

const StatusInlineEditor = ({
  anchorEl = null, issueStatuses, currentStatusId = null, isOpen, onClose, onSelect
}) => {
  const handleOptionClick = useCallback(event => {
    const { value } = event.currentTarget.dataset
    if (!value)
      return
    onSelect(value)
    onClose()
  }, [onSelect, onClose])

  const renderOption = useCallback(status => (
    <button
      key={status.id}
      aria-selected={String(status.id) === String(currentStatusId)}
      className={SEARCHABLE_MENU_ROW_CLASS}
      data-value={status.id}
      role="option"
      type="button"
      onClick={handleOptionClick}
    >
      <StatusDot color={status.color} label={status.name} />
    </button>
  ), [currentStatusId, handleOptionClick])

  return (
    <SearchableMenu
      anchorEl={anchorEl}
      ariaLabel="Modifier le statut"
      filterBy={filterByName}
      isOpen={isOpen}
      items={issueStatuses}
      renderItem={renderOption}
      searchName="status-editor-search"
      onClose={onClose}
    />
  )
}

StatusInlineEditor.propTypes = {
  anchorEl: PropTypes.instanceOf(Element),
  currentStatusId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isOpen: PropTypes.bool.isRequired,
  issueStatuses: PropTypes.arrayOf(PropTypes.shape({
    category: PropTypes.string,
    color: PropTypes.string,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })),
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
}

StatusInlineEditor.defaultProps = {
  anchorEl: null,
  currentStatusId: null,
  issueStatuses: []
}

export default StatusInlineEditor
